import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import classNames from 'classnames';
require('npm-zepto');
import { Logout } from '@dbk/ui-icons';
import DbText from '../../../assets/svgs/db-text.js';

class AppNavAdmin extends Component {
  constructor(props) {
    super(props);
  }

  handleLogoutPress = (selected) => {
    this.props.auth.onLogout();
  };


  WebNav(heightValue, widthValue) {
    const {
      i18n: { messages },
      marque: { loginDissmiss },
    } = this.props;

    const currentPath = this.props.ui.history.currentLocation.pathname;
    const lastSegment = currentPath.split('/').pop();


    let titleMsg = 'app.common.marque.welcomeAdmin';
    if (lastSegment === 'alertmanagement' || lastSegment === 'alertlist') titleMsg = 'app.alert.message.management';
    if (currentPath.indexOf('docsigncenter') !== -1) titleMsg = 'app.docsigncenter';


    return (

      <div className='nav-content-web'>
        <DbText className={'logo-web'} />
        <div className={"show-for-large"}>
          <a className={'nav-text-margin'}>
            <div className={classNames({ label: true })} >
              {messages[titleMsg]}
            </div>
          </a>
        </div>
        <div className="nav-icon-group-admin">
          <span
            className={'margin-left-20 margin-right-20 pointer logoutPopup'}
            onClick={this.handleLogoutPress}
          >
            <Logout width={24} height={24} color="#999" />
          </span>
        </div>
      </div >
    );

  }

  render() {
    return (
      <section className={'app-nav'}>
        <div className={'side-menu'}>
          {this.WebNav(35, 35)}
        </div>
      </section>
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      onLogout: { $call: 'logout' },
    },
    i18n: {
      messages: true,
    },
    marque: {
      loginDissmiss: true,
    },
    ui: {
      history: {
        currentLocation: {
          pathname: true,
        },
      },
    },
  },
})(AppNavAdmin);

